commusoftCommon.service('changeStatusDrop', function(){
    this.changeStatus = {};
    this.setData = function setData(category, fullObject) {
        this.changeStatus[category] = fullObject;
    }
    this.getData = function getData(category){
        return this.changeStatus[category]
    }
});